import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { Flex, Link } from 'rebass';

import { Text } from '../Base';
import { SPACE, FONT_SIZE, COLOR } from '../Theme';

const AddExamErrorModal = ({ open, onClose }) => {
  return (
    <Modal size="tiny" open={open} onClose={onClose}>
      <Modal.Header>พบข้อผิดพลาด</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Flex justifyContent="center" flexDirection="row">
            <Text textAlign="center">{`ไม่สามารถเพิ่มวิชาสอบได้`}</Text>
            <Text mr={2}>{`โปรดติดต่อ Line: `}</Text>
            <Link href={'https://line.me/R/ti/p/%40tcastermock'} color="primary">
              @tcastermock
            </Link>
          </Flex>
        </Modal.Description>
      </Modal.Content>
      <Flex justifyContent="flex-end" alignItems="center" p={SPACE.medium}>
        <Button onClick={onClose} primary circular>
          <Text is="span" fontWeight="500" fontSize={FONT_SIZE.small} color={COLOR.white}>
            ปิดหน้าต่าง
          </Text>
        </Button>
      </Flex>
    </Modal>
  );
};

export default AddExamErrorModal;
